<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
    <path d="M10 16.5l6-4.5-6-4.5v9z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
</template>
